<template>
  <span
    ref="marqueeWrap"
    class="call-select-marquee"
    :class="computedMarqueeClass">
    <span
      ref="marqueeInner"
      class="call-select-marquee__inner"
      :style="computedMarqueeStyle">
      <span
        ref="marqueeText"
        class="call-select-marquee__text">{{ text }}</span>
      <span
        v-if="dataMarqueeOverflow"
        class="call-select-marquee__text call-select-marquee__text--clone"
        aria-hidden="true">{{ text }}</span>
    </span>
  </span>
</template>

<script>
import selectMarqueeOption from '@/mixins/select/selectMarqueeOption';

export default {
  name: 'CallSelectMarqueeOption',
  mixins: [selectMarqueeOption],
  props: {
    text: {
      type: [String, Number],
      default: ''
    }
  }
};
</script>
